/**
 * The settings route — ONE route, and deliberately not a destination
 * (WEB TIER A · WT7).
 *
 * `settings` is mounted through the `routes.extra.ts` seam like every other
 * feature, INSIDE `RequireSession` + `RequireCountry` + `AppShell`: the page
 * reads the seat off the session and the country off the URL, and both are
 * resolved by the time it renders.
 *
 * It is NOT in `domain/nav.ts` and gains no row there. `settings.html` asserts
 * that the sidebar still draws its 19 destinations in 6 sections on this page,
 * and plan §11's "no new IA" holds: the way in is the sidebar identity block —
 * `components/shell/ProfileMenu.tsx`'s Settings item — which is where the shell
 * already puts a caret.
 *
 * No provider layout. The page raises no toast: every outcome it has is stated
 * in place (the password result on its own row, the theme and density in the
 * rows they change), so a ToastProvider here would be a stack with nothing to
 * say.
 */

import type { RouteObject } from 'react-router-dom';
import { SettingsPage } from './SettingsPage';

export const settingsRoutes: RouteObject[] = [{ path: 'settings', element: <SettingsPage /> }];
